
import moment from "moment";
import React, { useEffect, useState, useCallback } from "react";
// import { socket } from '../../Socket/page';
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { RingLoader } from "react-spinners";
// import { io } from 'socket.io-client'
import { ToastContainer, toast } from "react-toastify";
import Footer from "../../footer/page";
import Api from "../../Api/Api";

function Page() {
  const [leaderProfileData, setleaderProfileData] = useState([]);
  const [fademodel, setfademodel] = useState(false);
  const mongoid = localStorage.getItem("UserIdMongo");

  const [gamePlayerData, setgamePlayerData] = useState("");
  const [AlertDataDisplay, setAlertDataDisplay] = useState(false);
  const [fademodelliveUser, setfademodelliveUser] = useState(false);
  const [Liveuser, setLiveuser] = useState(0);
  const [gamelevel, setGameLevel] = useState();
  const [profile, setProfile] = useState({});
  const [userData, setUserData] = useState();
  const [loading, setLoading] = useState(false);
  const [gameNoAuth, setGameNoAuth] = useState(false);
  const [operation, setOperation] = useState({});
  const [displayMsg, setDisplayMsg] = useState(false);
  const [fademodelLevelSelect, setfademodelLevelSelect] = useState(false);
  const [selectedLevel, setSelectedLevel] = useState();
  const [Msg, setMsg] = useState(false);
  const [isGameLoad, setIsGameLoad] = useState(false);
  const [Leveloption, setLeveloption] = useState([]);
  const [isFreeLoad, setIsFreeLoad] = useState(false);

  const navigate = useNavigate();
  
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5; // Set the number of items per page

  // ... existing functions ...

  // Calculate the current items to display
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = leaderProfileData.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  // Calculate total pages
  const totalPages = Math.ceil(leaderProfileData.length / itemsPerPage);

  const [userbalance, setUserbalance] = useState();

  const Auth = localStorage.getItem("Quizetoken");
  // console.log("Auth----->",datauser)
  const clientid = localStorage.getItem("UserIdclient");

  const getProfile = async () => {
    const token = localStorage.getItem("Quizetoken");
    if (!token) return; // Don't call API if user is not logged in
    
    try {
      const res = await Api.get("user/get-profile");
      // console.log("Profile", res.data.result);
      setProfile(res.data.result);
      setGameLevel(res.data?.result?.userCurrentLevel);
    } catch (error) {
      console.log("Error", error);
    }
    // }
  };

    const getLevel = async () => {
      const token = localStorage.getItem("Quizetoken");
      if (!token) return; // Don't call API if user is not logged in
      
      let options = [];
      try {
        const res = await Api.get("user/gamesLevel");
        // console.log("Profile===>", res.data.result);
        setUserData(res.data?.result);
        
        if (!res.data.success) {
          // console.log("!res.success");
          options.push({ value: 1, label: `Level 1` });
        } else if (res.data.result == null || !res.data.result) {
          // console.log("!result == null, !res");
          options.push({ value: 1, label: `Level 1` });
        } else {
          const userLevel = res?.data?.result;
          // console.log("res.success", userLevel);
  
          // options.push({ value: 1, label: `Level 1` });
          userLevel.map(i => options.push({ value: i, label: `Level ${i}` }));
  
        }
        
        setLeveloption(options);
        // console.log("option", options);
      } catch (error) {
        console.log("Error profile", error);
          options.push({ value: 1, label: `Level 1` });
        setLeveloption(options);
  
      }
      // }
    };

    
  const Getbalance = useCallback(async () => {
    //   const formData= new FormData()
    //   formData.append('userid',1)
    try {
      const response = await Api.get(
        `/user/userWalletBalance?userid=${clientid}`
      );
      // console.log("Dattataat---->payyyy", response.data);
      setUserbalance(response.data.result);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const getOperation = async () => {
    try {
      const res = await Api.get(`/admin/operation`);
      setOperation(res.data.result?.operationData[0]);
      // console.log("operation", res.data.result?.operationData[0]);
    } catch (error) {
      console.log(error);
    }
  };

  const WithdrawalBalance = async (level) => {
    // const formData = new FormData();
    // formData.append("userid", 1);
    try {
      const response = await Api.patch(
        `/user/game-payment`,
        { gameLevel: level }
      );
      if (response.data.success) {
        // console.log("Payment id---->", response.data.result);
        setgamePlayerData(response.data.result);
        localStorage.setItem("GameId", response?.data?.result?.user?.gameId);
        localStorage.setItem("gameLevel", response?.data?.result?.gameLevel);
        return response.data.result;
      } else {
        setgamePlayerData("");
        toast(response.data.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          type: "error",
        });
      }
    } catch (error) {
      // console.log(error);
      toast(error.response.data.message, {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              type: "error",
            });
    }
  };

  const getUserLevel = async () => {
    const token = localStorage.getItem("Quizetoken");
    if (!token) return; // Don't call API if user is not logged in
    
    try {
      const res = await Api.get("user/gamesLevel");
      // console.log("Profile", res.data.result?.gameId);
      setUserData(res.data?.result);
      localStorage.setItem("GameId", res.data.result?.gameId);
    } catch (error) {
      console.log("Error profile", error);
    }
    // }
  };
  const handlepopupCash = async () => {
    // setfademodelLevelSelect(false);
    setIsGameLoad(true);
    // setLoading(true)
    const token = localStorage.getItem("Quizetoken");
    // console.log("Level",selectedLevel);
    if (!selectedLevel) {
      // setLoading(false)
      // console.log("msg is true");
      setMsg(true);
    } else {
      // console.log("msg is false");

      if (token) {
        // console.log("cash popup => ", Liveuser);
        // if (userbalance >= operation?.amount_deduct) {
          // WithdrawalBalance();
          // const gameData=gamePlayerData
          // setLoading(false);
          const gameData = await WithdrawalBalance(selectedLevel);
          // console.log("llllll22222=> ", gamePlayerData?.user?.gameId);
           
          if (gameData?.success === true) {
            // setfademodelliveUser(true);
            // setfademodelLevelSelect(true);
             navigate("/gamearea", {
               state: {
                //  GameId: gamePlayerData?.user?.gameId ,
                 Level: selectedLevel,
               },
             });
          } else {
            // WithdrawalBalance();

            setfademodelLevelSelect(false);

            // if (gameData.user.userCurrentLevel === 1) {
            //   navigate("/gamearea", {
            //     state: { popupclose: "popupclose", GameId: userbalance.GameId, gameLevel:gameData.user.userCurrentLevel },
            //   });
            // } else if (gameData.user.userCurrentLevel === 2) {
            //   navigate("/levelone", {
            //     state: { popupclose: "popupclose", GameId: userbalance.GameId,gameLevel:gameData.user.userCurrentLevel },
            //   });
            // } else if (gameData.user.userCurrentLevel === 3) {
            //   navigate("/levelone", {
            //     state: { popupclose: "popupclose", GameId: userbalance.GameId,gameLevel:gameData.user.userCurrentLevel },
            //   });
            // }
          }
        // } else {
        //   toast(
        //     "You don't have insufficient balance. Please recharge your wallet.",
        //     {
        //       position: "top-right",
        //       autoClose: 2000,
        //       hideProgressBar: false,
        //       closeOnClick: true,
        //       pauseOnHover: true,
        //       draggable: true,
        //       progress: undefined,
        //       type: "error",
        //     }
        //   );
        // }
        setfademodel(false);
        // socket.emit("joinRoom", mongoid);
      } else {
        navigate("/login");
        setfademodel(false);
      }
    }
    setIsGameLoad(false)
  };

  const handlepopupFree = async () => {
    setIsFreeLoad(true);
    try {
      if (Auth) {
        //    setfademodel(false)
        const res = await Api.get("/user/free-game-played");
        if (res.data.success) {
          // console.log("demo game", res.data.result);
          // console.log("llllll=>sssss", Liveuser);
          navigate("/demogame", { state: "popupclose" });
          setfademodel(false);
        } else {
          toast(res.data.message, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            type: "error",
          });
        }

        // socket.emit("joinRoom",mongoid)
      } else {
        navigate("/login");
        setfademodel(false);
      }
    } catch (error) {
      // console.log("error", error);
      toast(error.response.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        type: "error",
      });
    }
    setIsFreeLoad(false)
  };

  // const handlepopupCash= () => {
  //     const token = localStorage.getItem('Quizetoken')
  //     if(token){
  //     //    setfademodel(false)
  //         console.log("check token => ", token);
  //         navigate('/gamearea',{state:'popupclose'})
  //         setfademodel(false)

  //         // socket.emit("joinRoom",mongoid)

  //         // console.log("socket",socket)
  //     }
  //     else
  //     {

  //         navigate('/login')

  //         setfademodel(false)
  //     }

  // }

  const leaderFatchData = async () => {
    try {
      setLoading(true);
      const userIdData = localStorage.getItem("UserIdMongo");
      // console.log("idiiiidididid", userIdData);
      // const Auth=localStorage.getItem("Quizetoken")
      if (Auth) {
        const res = await Api.get("/user/get-users", {
          params: { userid: userIdData },
        });
        // console.log("res----->leaderfaafafafa", res.data.result);
        setleaderProfileData(res.data.result);
      }
    } catch (error) {
      console.log(error);
    }

    setLoading(false);
  };

  useEffect(() => {
    Getbalance();
    getOperation();
  }, []);

  useEffect(() => {
    getProfile();
    leaderFatchData();
    getUserLevel();
    getLevel();
  }, [Auth]);

    useEffect(()=>{
      if (Leveloption.length === 1 && Leveloption[0].value === 1) {
        setSelectedLevel(1);
        setMsg(false);
      }
    },[Leveloption])

  return (
    <>
      {loading ? (
        <div className="d-flex justify-content-center">
          {/* <RingLoader color="rgb(50 92 213)" size="100" /> */}
        </div>
      ) : (
        <>
          <section className="call-to-action overflow-hidden">
            <div className="container ">
              <div className="row justify-content-between align-items-center">
                <div className="col-lg-5">
                  <div className="sec-img mt-0 mb-10 mb-sm-15 mb-lg-0 text-start d-center position-relative">
                    <a>
                      {" "}
                      <img
                        src="/assets/images/call-to-action-circle.png"
                        alt="Image"
                      />{" "}
                    </a>
                    <div className="video-bg position-absolute">
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                    <div className="play-btn pos-btn">
                      {/* <a data-bs-toggle="modal" data-bs-target="#exampleModal"  className=" " style={{ '--x': '111px', '--y': '27px' }}>
                                <i className="fa-regular fa-circle-play"></i>  Play Now
                            </a> */}

                      {/* <a  className="box-style btn-box d-center"  onClick={() => setfademodel(true)}> 
                                       <i className="fa-regular fa-circle-play"></i> Play Now
                                    </a> */}
                      <a
                        className="box-style btn-box d-center"
                        onClick={() => {
                          if (!Auth) {
                            // console.log("no auth");
                            setGameNoAuth(true);
                          } else {
                            // console.log("auth");
                            setfademodel(true);
                          }
                        }}

                        // onClick={() => {
                        //   if (!Auth) {
                        //     console.log("no auth");
                        //     setGameNoAuth(true);
                        //   } else {
                        //     console.log("auth");
                        //   setfademodel(true);
                        //   }
                        // }}
                      >
                        <i className="fa-regular fa-circle-play"></i> Play Now
                      </a>
                    </div>
                  </div>
                </div>
                {Auth && (
                  <div className="col-lg-6">
                    <div className="leaderboard">
                      <h2
                        className="text-center"
                        style={{ fontWeight: "bold" }}
                      >
                        Team Leaderboard
                      </h2>
                      <div className="leaderboard-box-1 mt-5 mb-3">
                        <h5>Serial No.</h5>
                        <h5>UserName</h5>
                        <h5>Points</h5>
                        <h5>Timing</h5>
                        <h5>Level</h5>
                      </div>
                      {Auth && leaderProfileData.length > 0 ? (
                        leaderProfileData?.map((item, index) => (
                          <div
                            className="leaderboard-box"
                            key={index}
                            style={{
                              marginBottom: "7px",
                              gridTemplateColumns: "6% 45% 15% 15% 20%",
                            }}
                          >
                            <div>
                              <p
                                className="text-center"
                                style={{ marginBottom: "0rem" }}
                              >
                                {index + 1}
                              </p>
                            </div>
                            <div className="profil-lead">
                              {/* <img src="/assets/images/team-members-1.png" /> */}
                              <a
                                className="profile-icon"
                                style={{ width: "20px", height: "20px" }}
                              >
                                <i className="fa-regular fa-user"></i>
                              </a>
                              {/* <h5>{item.userName}</h5> */}
                              <h5>{item.userId.userName}</h5>
                            </div>

                            <p
                              className="text-center"
                              style={{ marginBottom: "0rem" }}
                            >
                              {item.score}
                            </p>
                            <p
                              className="text-center"
                              style={{ marginBottom: "0rem" }}
                            >
                              {Math.floor(item.timeTaken / 60)}m:
                              {Math.floor(item.timeTaken % 60)}s
                              {/* {Math.floor((item.timeTaken / 60000) % 60)}m:
                            {(item.timeTaken / 1000) % 60}s */}
                            </p>
                            <p
                              className="text-center"
                              style={{ marginBottom: "0rem" }}
                            >
                              {item.gameLevel}
                            </p>
                          </div>
                        ))
                      ) : (
                        <p className="text-center">No data found</p>
                      )}
                    </div>
                  </div>
                )}

                {/* {leaderProfileData.length > 0 ? (

    <div className="pagemodify" style={{marginLeft: '868px'}}> 
    <div className="pok-pagination" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-easing="ease-in" >
    {/* <div className="pagination"> 
    <ul>
    <li>
        <a onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1}><i className="fa-solid fa-angles-left"></i></a>
        {/* <span>Page {currentPage} of {totalPages}</span> 
    </li>
    <li>
                            <a onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1}>01</a>
                        </li>
                      
    <li>
    <li className="dotted">
                            <i className="fa-solid fa-ellipsis"></i>
                        </li>


        <a onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages}><i className="fa-solid fa-angles-right"></i></a>
        </li>
    </ul>
    </div>
    </div>) : ''
} */}
              </div>
            </div>
          </section>
          {/* <Footer /> */}
        </>
      )}

      {/* <div className='modal fade show' id="exampleModal"  aria-labelledby="exampleModalLabel" aria-hidden="true" style={{display:fademodel ? 'block':'none',paddingTop:'190px'}}>
  <div className="modal-dialog">
    <div className="modal-content" style={{backgroundColor:'#b6b8dc'}}>
     
      <div className="modal-body">
	   <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={()=>setfademodel(false)}></button>
	  
	  <div className="logo poup"> 
                <Link to='/'><img src="/assets/images/logo-text.png" className="logo-text d-xxl-block  " alt="logo-text" /></Link>
            </div>
	  
	  <div className="d-flex justify-content-center align-items-center">
         <div className="btn-area alt-bg">
                                    <a  onClick={()=>handlepopupCash()} className="box-style btn-box d-center">
                                        Play for Cash 
                                    </a>
                                </div>
								 <div className="btn-area alt-bg border-line">
                                    <a onClick={()=>handlepopupCash()}  className="box-style btn-box d-center">
                                        Play for Free  
                                    </a>
                                </div>
								
								</div>
      </div>
     
    </div>
  </div>
    </div>  */}

      {gameNoAuth ? (
        <div
          className="modal fade show"
          id="exampleModal"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
          style={{
            display: gameNoAuth ? "block" : "none",
            paddingTop: "190px",
          }}
        >
          <div className="modal-dialog">
            <div
              className="modal-content"
              style={{ backgroundColor: "#b6b8dc" }}
            >
              <div
                className="modal-body"
                style={{ paddingTop: "8px", paddingBottom: "13px" }}
              >
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setGameNoAuth(false)}
                ></button>

                <div className="logo poup">
                  <Link to="/">
                    <img
                      src="/assets/images/logo-text.png"
                      className="logo-text d-xxl-block  "
                      alt="logo-text"
                    />
                  </Link>
                </div>

                <div className="d-flex justify-content-center align-items-center">
                  <div className="btn-area alt-bg">
                    <h5 style={{ color: "#20205f", textAlign: "center" }}>
                      To play game, please login
                    </h5>
                    <div className="btn-area alt-bg border-line">
                      <div className="btn-area alt-bg border-line">
                        <a
                          onClick={() => {
                            setGameNoAuth(false);
                            navigate("/login");
                            // setfademodelLevelSelect(true);
                          }}
                          className="box-style btn-box d-center hoverstyle"
                          // style={{ marginTop: "2px" }}
                        >
                          {loading ? "Please wait" : "Login"}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}

      {/* displaying msg when user plays for cash */}
      {displayMsg ? (
        <div
          className="modal fade show"
          id="exampleModal"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
          style={{
            display: displayMsg ? "block" : "none",
            paddingTop: "190px",
          }}
        >
          <div className="modal-dialog">
            <div
              className="modal-content"
              style={{ backgroundColor: "#b6b8dc" }}
            >
              <div className="modal-body">
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setDisplayMsg(false)}
                ></button>

                <div className="logo poup">
                  <Link to="/">
                    <img
                      src="/assets/images/logo-text.png"
                      className="logo-text d-xxl-block  "
                      alt="logo-text"
                    />
                  </Link>
                </div>

                <div className="d-flex justify-content-center align-items-center">
                  <div className="btn-area alt-bg">
                    <h5 style={{ color: "#20205f", textAlign: "center" }}>
                      For playing game for Cash, you will be charged $
                      {operation.amount_deduct} for Level-1, from your WSA
                      Available Cash Wallet per game.
                    </h5>
                    <div className="btn-area alt-bg border-line">
                      <div className="btn-area alt-bg border-line">
                        <a
                          onClick={() => {
                            setDisplayMsg(false);
                            handlepopupCash();
                            // setfademodelLevelSelect(true);
                          }}
                          className="box-style btn-box d-center hoverstyle"
                          // style={{ marginLeft: "155px", marginTop: "12px" }}
                        >
                          {loading ? "Please wait" : "Continue"}
                        </a>

                        <a
                          onClick={() => {
                            setDisplayMsg(false);
                            // setfademodelLevelSelect(true);
                          }}
                          className="box-style btn-box d-center hoverstyle"
                          // style={{ marginLeft: "155px", marginTop: "12px" }}
                        >
                          Cancel
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
      <div
        className="modal fade show"
        id="exampleModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        style={{ display: fademodel ? "block" : "none", paddingTop: "190px" }}
      >
        <div className="modal-dialog">
          <div className="modal-content" style={{ backgroundColor: "#b6b8dc" }}>
            <div className="modal-body">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setfademodel(false)}
              ></button>

              <div className="logo poup">
                <Link to="/">
                  <img
                    src="/assets/images/logo-text.png"
                    className="logo-text d-xxl-block  "
                    alt="logo-text"
                  />
                </Link>
              </div>

              <div className="d-flex justify-content-center align-items-center">
                <div className="btn-area alt-bg">
                  {/* <h5 style={{ color: "white", textAlign: "center" }}>
                          When you play game for Cash, then we will deduct $2 from
                          your wallet
                        </h5> */}
                  <div className="btn-area alt-bg border-line">
                    {Auth ? (
                      <div className="btn-area alt-bg border-line">
                        <a
                          // onClick={() => setfademodelLevelSelect(true)}
                          onClick={() => {
                            // setDisplayMsg(true);
                            setfademodelLevelSelect(true);
                            if(operation.landingPage)
                              navigate("/info");
                            else 
                              setfademodel(false);
                          }}
                          className="box-style btn-box d-center hoverstyle"
                          // style={{ marginLeft: "155px", marginTop: "12px" }}
                        >
                          {loading ? "Please wait" : "Play for Cash"}
                        </a>
                      </div>
                    ) : (
                      ""
                    )}

                    <div className="btn-area alt-bg border-line">
                      <a
                        onClick={() => handlepopupFree()}
                        className="box-style btn-box d-center hoverstyle"
                      >
                        {isFreeLoad ? "Please wait..." : "Play for Free"}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade show"
        id="exampleModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        style={{
          display: fademodelliveUser ? "block" : "none",
          paddingTop: "190px",
        }}
      >
        <div className="modal-dialog">
          <div className="modal-content" style={{ backgroundColor: "#b6b8dc" }}>
            <div className="modal-body">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setfademodelliveUser(false)}
              ></button>

              <div className="logo poup">
                <Link to="/">
                  <img
                    src="/assets/images/logo-text.png"
                    className="logo-text d-xxl-block  "
                    alt="logo-text"
                  />
                </Link>
              </div>

              <div className="d-flex justify-content-center align-items-center">
                <div className="btn-area alt-bg">
                  <h5 style={{ color: "red", textAlign: "center" }}>
                    Please wait for the other player to finished this level
                  </h5>
                </div>
                {/* <div className="btn-area alt-bg border-line">
                                    <a onClick={()=>handlepopupFree()}  className="box-style btn-box d-center">
                                        Play for Free  
                                    </a>
                                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade show"
        id="exampleModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        style={{
          display: fademodelLevelSelect ? "block" : "none",
          paddingTop: "190px",
        }}
      >
        <div className="modal-dialog">
          <div className="modal-content" style={{ backgroundColor: "#b6b8dc" }}>
            <div className="modal-body">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setfademodelLevelSelect(false)}
              ></button>

              <div className="logo poup">
                <Link to="/">
                  <img
                    src="/assets/images/logo-text.png"
                    className="logo-text d-xxl-block  "
                    alt="logo-text"
                  />
                </Link>
              </div>

              <div className="d-flex justify-content-center align-items-center">
                <h5>Please select the level you want to play.</h5>
              </div>

              <div className="dropdown-menu1">
                <select
                  className="form-control"
                  onChange={(e) => {
                    // console.log("Slected Level", e.target.value);
                    setSelectedLevel(e.target.value);
                    if (e.target.value) setMsg(false);
                  }}
                  // onClick={() => }
                >
                  {/* <option value="">Select Level</option>
                        <option value="1">Level 1</option>
                        <option value="2">Level 2</option>
                        <option value="3">Level 3</option>
                        <option value="4">Level 4</option>
                        <option value="5">Level 5</option>
                        <option value="6">Level 6</option>
                        <option value="7">Level 7</option> */}

                  {Leveloption.length === 1 && Leveloption[0].value === 1 ? (
                    <option value={Leveloption[0].value}>
                      {Leveloption[0].label}
                    </option>
                  ) : (
                    <>
                      <option value="">Select Level</option>
                      {Leveloption.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </>
                  )}
                </select>
                <button
                  onClick={(e) => {
                    if (selectedLevel == 1) {
                      setfademodelLevelSelect(false);
                      setDisplayMsg(true);
                    } else handlepopupCash();
                    // navigate("/gamearea", {
                    //   state: {
                    //     GameId: gamePlayerData?.user?.gameId,
                    //     Level: selectedLevel,
                    //   },
                    // });
                  }}
                  style={{ marginLeft: "37%" }}
                  disabled={!Msg ? false : true}
                  // href="quiz.html"
                  className="mt-4 box-style btn-box d-center mx-50"
                >
                  {isGameLoad ? "Please Wait..." : "Play Now"}
                </button>
                {Msg ? (
                  <>
                    <p style={{ color: "red" }}>Please select the level</p>
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Page;
